module.exports = __webpack_public_path__ + "img/logo.47bbce84.png";